import { Checkbox } from 'react-bootstrap';
import { AppointmentNotFound } from './appointmentNotFound';

export class AssignedDoctorSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: true,
    };
  }

  render() {
    return (
      <div>
        {this.props.MedicalAvailable.AssignedDoctor && this.props.MedicalAvailable.AssignedDoctor.FullName !== '' ? (
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" id="assignedDoctorSelector">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 content-medical">
              <h4>
                {' '}
                {this.props.personalDoctor
                  ? parseText('Form.Content.SeleccioneMedicoPersonal')
                  : parseText('Form.Content.SeleccioneMedicoTratante')}
              </h4>
              <form>
                <Checkbox                
                  defaultChecked={this.props.checkedDoctor}
                  className="medicoCheck"
                  onClick={this.props.DoctorSelected}
                >
                  <h4>
                    Dr. {this.props.MedicalAvailable.AssignedDoctor.FullName} -{' '}
                    <span>
                      {this.props.MedicalAvailable.AssignedDoctor.SpecialityName === null
                        ? 'Médico de trámite'
                        : this.props.MedicalAvailable.AssignedDoctor.SpecialityName}
                    </span>
                  </h4>
                </Checkbox>
              </form>
            </div>
          </div>
        ) : (
          <div>
            <AppointmentNotFound
              NoLink={this.props.ShowLink}
              NotFoundIcon={this.props.Icon}
              NotFoundMessage={this.props.Message}
              TargetContent={this.props.Target}
              TargetURL={this.props.TargetURL}
            />
          </div>
        )}
      </div>
    );
  }
}
